// extracted by mini-css-extract-plugin
export default {"icon":"src-components-Modules-Components-TabStyle-css-module__icon--SpfQX"};